import { useEffect } from 'react';
import { useComponentTranslations, useComponentMethods } from 'js/hooks/component';
import { useAppSelector } from 'js/store/hooks';
import { getScript } from 'js/utils/scripts.util';

import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';
import { useIsMounted } from 'js/hooks/useIsMounted';

export const useGetExternalScript = () => {
    const isMounted = useIsMounted();
    const translate = useComponentTranslations();
    const dispatch = useDynamicReducerDispatch();
    const { showComponentError } = useComponentMethods();
    const ssoPasExternalJsUrl = useAppSelector((state) => state.ssoPasExternalJsUrl);

    useEffect(() => {
        if (!ssoPasExternalJsUrl) {
            showComponentError(translate('playtech.mobile.system.bankIDAuth.externalScript.notConfigured'));
        }

        getScript(ssoPasExternalJsUrl)
            .then(() => {
                isMounted() && dispatch(actions.setIsExternalScriptLoaded(true));

                window.externalAuth?.cancel();
            })
            .catch(() => {
                isMounted() && showComponentError(translate('playtech.mobile.system.bankIDAuth.externalScript.notLoaded'));
            });
    }, [dispatch, isMounted, showComponentError, ssoPasExternalJsUrl, translate]);
};
